'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
require('prop-types');
var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var classNames = require('classnames');
var CircularProgress = require('../../node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var style = {
  description: {},
  root: {
    height: '100%'
  },
  fullPage: {
    height: '100vh'
  }
};

var CenteredSpinner = function CenteredSpinner(props) {
  var classes = props.classes,
      spinnerSize = props.spinnerSize,
      description = props.description,
      descriptionVariant = props.descriptionVariant,
      fullPage = props.fullPage;
  return React__default["default"].createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    spacing: 16,
    className: classNames__default["default"](classes.root, defineProperty({}, classes.fullPage, fullPage))
  }, React__default["default"].createElement(CircularProgress["default"], {
    size: spinnerSize,
    color: "primary",
    variant: "indeterminate"
  }), ObjectHelper.isPresent(description) ? React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: descriptionVariant,
    className: classes.description
  }, description)) : null);
};

var CenteredSpinner$1 = withStyles(style)(CenteredSpinner);
CenteredSpinner.defaultProps = {
  description: '',
  descriptionVariant: 'body1',
  spinnerSize: 60,
  fullPage: false
};

module.exports = CenteredSpinner$1;
